// https://github.com/nicolas-van/react-bootstrap-confirmation (MIT License)
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { confirmable, createConfirmation } from 'react-confirm';
import { ButtonVariant } from 'react-bootstrap/esm/types';

type ConfirmationOptions = {
  title?: string;
  yesText?: string;
  yesButtonStyle?: ButtonVariant;
  noText?: string;
  noButtonStyle?: ButtonVariant;
  cancelText?: string;
  cancelButtonStyle?: ButtonVariant;
}

type ConfirmationProps = {
  show: boolean;
  proceed: (...args: any[]) => any;
  dismiss: (...args: any[]) => any;
  cancel: (...args: any[]) => any;
  confirmation: string;
} & ConfirmationOptions;

const Confirmation = ({ show, proceed, dismiss, cancel, confirmation, title,
  yesText, noText, cancelText, yesButtonStyle, noButtonStyle, cancelButtonStyle, ...options }: ConfirmationProps) => {
  const header = title ? (
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
  ) : undefined;
  return (
    <Modal
      size="sm"
      show={show}
      onHide={() => proceed('cancel')}
      backdrop="static"
      centered
    >
      {header}
      <Modal.Body>{confirmation}</Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button
          variant={cancelButtonStyle ?? 'secondary'}
          onClick={() => proceed('cancel')}
        >
          {cancelText}
        </Button>
        <div className="d-flex align-items-center justify-content-end">
          <Button
            variant={noButtonStyle ?? 'secondary'}
            onClick={() => proceed('no')}
          >
            {noText}
          </Button>
          <Button
            variant={yesButtonStyle}
            onClick={() => proceed('yes')}
            className='ml-2'
          >
            {yesText}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

const confirmLow = createConfirmation(confirmable(Confirmation));

/**
 * Returns 'yes', 'no', or 'cancel' depending on button clicked.
 */
export const confirm = (message, options: ConfirmationOptions = {}): Promise<string> => {
  return confirmLow(Object.assign({ confirmation: message }, options));
};
